var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swip"},[_c('van-swipe',{attrs:{"autoplay":3000}},_vm._l((_vm.images),function(image,index){return _c('van-swipe-item',{key:index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(image),expression:"image"}]})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }